import React, { useCallback, useEffect, useState } from 'react';
import { Modal, Slider, Typography, Spin } from 'antd';
import Cropper from 'react-easy-crop';
import cropGif from '../../utils/cropGif';

const { Text } = Typography;

const GifCropModal = ({ open, file, aspect, outputSize, onCancel, onCropped }) => {
  const [previewUrl, setPreviewUrl] = useState('');
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [rotation, setRotation] = useState(0);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [processing, setProcessing] = useState(false);
  const [modalReady, setModalReady] = useState(false);

  useEffect(() => {
    if (!file) {
      setPreviewUrl('');
      return undefined;
    }
    const url = URL.createObjectURL(file);
    setPreviewUrl(url);
    setCrop({ x: 0, y: 0 });
    setZoom(1);
    setRotation(0);
    setCroppedAreaPixels(null);
    return () => URL.revokeObjectURL(url);
  }, [file]);

  const onCropComplete = useCallback((_, areaPixels) => {
    setCroppedAreaPixels(areaPixels);
  }, []);

  const handleOk = async () => {
    if (!croppedAreaPixels || !file) return;
    try {
      setProcessing(true);
      const cropped = await cropGif(file, croppedAreaPixels, outputSize);
      onCropped(cropped);
    } catch (err) {
      console.error('GIF crop error:', err);
    } finally {
      setProcessing(false);
    }
  };

  return (
    <Modal
      open={open}
      title="Crop GIF"
      onCancel={processing ? undefined : onCancel}
      onOk={handleOk}
      okText={processing ? 'Processing…' : 'Crop & Upload'}
      okButtonProps={{ loading: processing, disabled: !croppedAreaPixels }}
      cancelButtonProps={{ disabled: processing }}
      maskClosable={!processing}
      destroyOnClose
      width={640}
      afterOpenChange={(opened) => setModalReady(opened)}
    >
      <Spin spinning={processing} tip="Processing GIF frames…">
        <div style={{ position: 'relative', width: '100%', height: 360, background: '#000' }}>
          {previewUrl && modalReady && (
            <Cropper
              image={previewUrl}
              crop={crop}
              zoom={zoom}
              rotation={rotation}
              aspect={aspect}
              onCropChange={setCrop}
              onZoomChange={setZoom}
              onRotationChange={setRotation}
              onCropComplete={onCropComplete}
              objectFit="contain"
              restrictPosition
            />
          )}
        </div>
        <div style={{ marginTop: 16 }}>
          <Text style={{ display: 'block' }}>Zoom</Text>
          <Slider min={1} max={3} step={0.01} value={zoom} onChange={setZoom} />
          <Text style={{ display: 'block' }}>Rotation</Text>
          <Slider min={0} max={360} step={1} value={rotation} onChange={setRotation} />
        </div>
      </Spin>
    </Modal>
  );
};

export default GifCropModal;
